import * as axios from "axios";
const instance = axios.create({
    baseURL: '/hollihop/api/',
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
    }
});

const sendAPI = {
    saveToken(token, appId) {
        return instance.post(`/`, {token, appId} );
    },
    auth(token) {
        return instance.post(`/`, {"auth":{token}} );
    },
    setIntegration(status, appId) {
        return instance.post(`/`, {"integration": {status, appId}} );
    },
    saveUrl(url, appId){
        return instance.post(`/`, {"url": {url, appId}} );
    }
}

export default sendAPI